import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneWorkExperience = createAsyncThunk(
  "GetOneWorkExperience/GetOneWorkExperience",
  async (parameters, { rejectWithValue }) => {
    try {
    
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_WE_WorkExperience/GetOneWQ_NT_WE_WorkExperience",
        parameters
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteWorkExperience = createAsyncThunk(
  "DeleteWorkExperience/DeleteWorkExperience",
  async (parameters, { rejectWithValue }) => {
    try {
    
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_WE_WorkExperience/DeleteWQ_NT_WE_WorkExperience",
        parameters
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateWorkExperience = createAsyncThunk(
  "UpdateWorkExperience/UpdateWorkExperience",
  async (parameters, { rejectWithValue }) => {
    try {
    
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_WE_WorkExperience/UpdateWQ_NT_WE_WorkExperience",
        parameters
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddWorkExperience = createAsyncThunk(
  "AddWorkExperience/AddWorkExperience",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WQ_NT_WE_WorkExperience/AddWQ_NT_WE_WorkExperience",
        parameters
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const WorkExperience = createSlice({
  name: "VolunteerCommunityWork",
  initialState: {
    WorkExperience: {},
    loadingWorkExperience: false,
    errorWorkExperience: null,

    AddWorkExperience: {},
    loadingAddWorkExperience: false,
    errorAddWorkExperience: null,

    UpdateWorkExperience: {},
    loadingUpdateWorkExperience: false,
    errorUpdateWorkExperience: null,

    DeleteWorkExperience: {},
    loadingDeleteWorkExperience: false,
    errorDeleteWorkExperience: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetOneWorkExperience.pending, (state, action) => {
        state.loadingWorkExperience = true;
        state.WorkExperience = action.payload;
        state.errorWorkExperience = null;
      })
      .addCase(GetOneWorkExperience.fulfilled, (state, action) => {
        state.loadingWorkExperience = false;
        state.WorkExperience = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneWorkExperience.rejected, (state, action) => {
        state.loadingWorkExperience = false;
        state.errorWorkExperience = action.payload;
      })

      .addCase(DeleteWorkExperience.pending, (state, action) => {
        state.loadingDeleteWorkExperience = true;
        state.DeleteWorkExperience = action.payload;
        state.errorDeleteWorkExperience = null;
      })
      .addCase(DeleteWorkExperience.fulfilled, (state, action) => {
        state.loadingDeleteWorkExperience = false;
        state.DeleteWorkExperience = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteWorkExperience.rejected, (state, action) => {
        state.loadingDeleteWorkExperience = false;
        state.errorDeleteWorkExperience = action.payload;
      })

      .addCase(UpdateWorkExperience.pending, (state, action) => {
        state.loadingUpdateWorkExperience = true;
        state.UpdateWorkExperience = action.payload;
        state.errorUpdateWorkExperience = null;
      })
      .addCase(UpdateWorkExperience.fulfilled, (state, action) => {
        state.loadingUpdateWorkExperience = false;
        state.UpdateWorkExperience = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateWorkExperience.rejected, (state, action) => {
        state.loadingUpdateWorkExperience = false;
        state.errorUpdateWorkExperience = action.payload;
      })

      .addCase(AddWorkExperience.pending, (state, action) => {
        state.loadingAddWorkExperience = true;
        state.AddWorkExperience = action.payload;
        state.errorAddWorkExperience = null;
      })
      .addCase(AddWorkExperience.fulfilled, (state, action) => {
        state.loadingAddWorkExperience = false;
        state.AddWorkExperience = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddWorkExperience.rejected, (state, action) => {
        state.loadingAddWorkExperience = false;
        state.errorAddWorkExperience = action.payload;
      });
  },
});

export default WorkExperience.reducer;
